function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'coal': 'rgb(52, 59, 69)','ocean': 'rgb(25, 65, 113)','quiet-grey': 'rgb(65, 70, 68)','brick-red': 'rgb(143, 20, 2)','gold-black': 'rgb(255, 215, 0)','red-black': 'rgb(255, 0, 0)','green-black': 'rgb(0, 128, 0)','purple-black': 'rgb(120, 81, 169)','black-green': 'rgb(76, 187, 23)','octane': 'rgb(110, 28, 36)','picante': 'rgb(141, 63, 45)','olive-green': 'rgb(141, 139, 85)',};

    this.images = {'high-vis': 'url("//www.mycoolingstore.com/cdn/shop/files/highvis_120x.png?v=9261652907270017301")','wine': 'url("//www.mycoolingstore.com/cdn/shop/files/wine_120x.png?v=10628531438540199866")','blue-plaid': 'url("//www.mycoolingstore.com/cdn/shop/files/blueplaid_120x.png?v=14436029986134837430")','red-plaid': 'url("//www.mycoolingstore.com/cdn/shop/files/redplaid_120x.png?v=1421654347230845654")','hunter-green': 'url("//www.mycoolingstore.com/cdn/shop/files/hunter-green_120x.png?v=2186500629815330921")','lichen-green': 'url("//www.mycoolingstore.com/cdn/shop/files/lichen-green_120x.png?v=16893152270350664056")','sharkskin-grey': 'url("//www.mycoolingstore.com/cdn/shop/files/sharkskin-grey_120x.png?v=9091550636113270692")','black-olive-green': 'url("//www.mycoolingstore.com/cdn/shop/files/black-olive-green_120x.png?v=14662879427075440364")','black-quiet-shade-grey': 'url("//www.mycoolingstore.com/cdn/shop/files/black-quiet-shade-grey_120x.png?v=16507254253569608482")','mallard-blue': 'url("//www.mycoolingstore.com/cdn/shop/files/mallard_blue_120x.png?v=12756542493330190507")','realtree-edge': 'url("//www.mycoolingstore.com/cdn/shop/files/realtree-edge_120x.png?v=2024436539240359054")','navy-black': 'url("//www.mycoolingstore.com/cdn/shop/files/navy_120x.png?v=6035399562382825347")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
